import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <section className="section" style={{ textAlign: "center", paddingTop: 160 }}>
      <h2 className="sec-title" style={{ marginBottom: 16 }}>Page Not Found</h2>
      <p style={{ opacity: 0.75, marginBottom: 32 }}>
        That page drifted out of orbit. Let's get you back home.
      </p>
      <Link to="/" className="btn btn-primary">Return Home</Link>
    </section>
  );
}
